import { pxToRem } from '../../../../utils';
export default (function (siteVariables) {
  return {
    padding: pxToRem(7) + " " + pxToRem(3) + " " + pxToRem(7) + " " + pxToRem(11),
    // padding set to 1px less to account for 1px border
    iconSpace: pxToRem(12),
    iconSize: pxToRem(32),
    borderColor: siteVariables.colors.grey[200],
    borderRadius: pxToRem(3),
    backgroundColor: siteVariables.colors.grey[100],
    backgroundColorHover: siteVariables.colors.grey[150],
    textColor: siteVariables.colors.grey[750],
    textColorHover: siteVariables.colors.grey[750],
    boxShadow: siteVariables.shadowLevel1,
    focusBackgroundColor: undefined,
    focusColor: undefined,
    siblingsFocusColor: undefined,
    siblingsHoverColor: undefined,
    progressColor: siteVariables.colors.green[200],
    progressHeight: 4,
    headerFontSize: siteVariables.fontSizes.medium,
    headerFontWeight: siteVariables.fontWeightSemibold,
    headerLineHeight: siteVariables.lineHeightMedium,
    descriptionFontSize: siteVariables.fontSizes.small,
    descriptionFontWeight: siteVariables.fontWeightRegular,
    descriptionLineHeight: siteVariables.lineHeightDefault,
    // action variables
    actionHeight: pxToRem(32),
    actionMaxWidth: pxToRem(280),
    actionColor: siteVariables.colors.grey[750],
    actionPrimaryColor: siteVariables.colorScheme.brand.foreground,
    actionColorDisabled: siteVariables.colorScheme.brand.foregroundDisabled1,
    actionIconSize: pxToRem(16),
    actionLoaderBorderSize: pxToRem(2),
    actionLoaderSize: pxToRem(20),
    actionLoaderSvgHeight: pxToRem(1220),
    actionLoaderSvgAnimationHeight: pxToRem(-1200),
    actionFocusBorderRadius: pxToRem(3)
  };
});
//# sourceMappingURL=attachmentVariables.js.map
